import { Model } from "@vuex-orm/core";
import { required, decimal, maxLength } from "vuelidate/lib/validators";
import Batch from "./Batch";
import RawMaterial from "./RawMaterial";

export default class BatchRawOrigin extends Model {
  static entity = 'batchraworigins';

  static $fetch() {
    return this.api().get('BatchRawOrigins/')
  }
  static $put (id, data) {
    return this.api().put(`BatchRawOrigins/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`BatchRawOrigins/`, data)
  }
  static $delete (id) {
    return this.api().delete(`BatchRawOrigins/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.number(0),
      quantity: this.string("100"),
      quantityIcon: this.string("fas fa-weight"),
      units: this.string("g"),
      rawmaterial: this.belongsTo(RawMaterial, "rawmaterial_id"),
      rawmaterial_id: this.attr(null),
      batch: this.belongsTo(Batch, "batch_id"),
      batch_id: this.attr(null)
    };
  }

  toCreatePayload() {
    return {
      name: this.name,
      quantity: this.quantity,
      units: this.units,
      rawmaterial: this.rawmaterial_id,
      batch: this.batch_id
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        rawmaterial_id: { required },
        quantity: { required, decimal, maxLength: maxLength(13) },
        units: { required }
      }
    };
  }
}
